import { useEffect } from 'react';
import { useClockTick, usePracticeContext } from '../../contexts';
export function useScheduler(events, schedule, reset, seek, cursor, isReady = true) {
    const { clock, clockState, evaluator } = usePracticeContext();
    const clockTick = useClockTick();
    const { timing } = evaluator;
    useEffect(() => {
        clock.addEventListener('reset', reset);
        clock.addEventListener('seeked', seek);
    }, [clock, reset, seek]);
    useEffect(() => {
        if (schedule != null && clock.isRunning) {
            const nextUpdate = timing.tickTimestamp(clockTick.absTick + 2);
            while (cursor.current >= 0 && cursor.current < events.length && events[cursor.current].timestamp <= nextUpdate) {
                schedule(events[cursor.current++]);
            }
        }
    }, [clock, clockState, clockTick, cursor, events, isReady, schedule, timing]);
}
//# sourceMappingURL=eventScheduler.js.map